import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { NonLCCApprover } from '../../../types';

export interface ShipmentNonLCCApproversRequestParams {
  customerKey: number;
}

export const getNonLCCApproversListAPI = (params: ShipmentNonLCCApproversRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetLCCShipmentApproverList`,
  });
};

export type NonLCCApproversListResponse = NonLCCApprover[];

export const fetchNonLCCApproversList = async (
  params: ShipmentNonLCCApproversRequestParams,
): Promise<NonLCCApproversListResponse> => {
  const response: AxiosResponse<NonLCCApproversListResponse> = await getNonLCCApproversListAPI(params);
  return response.data;
};
